<template>
  <main-layout>
    <template slot="header">{{ title }}</template>

    <template slot="main">
      <a class="add-btn" @click="save">Save</a>
      <section v-if="round">
        <div class="section">
          <div class="col-left">
            <h2>About</h2>
          </div>
          <div class="col-right">
            <div class="form-group">
              <label>Title</label>
              <el-input type="text" v-model="round.title[lang]" auto-complete="off"></el-input>
            </div>
            <div class="form-group">
              <label>Description</label>
              <el-input type="text" v-model="round.description[lang]" auto-complete="off"></el-input>
            </div>
            <div class="form-group">
              <label>End date</label>
              <el-date-picker type="datetime" placeholder="Select date and time" v-model="closedate"></el-date-picker>
            </div>
            <div class="form-group">
              <label>Bonus point (offered to users who have made a no-fault)</label>
              <el-input-number v-model="round.allgoodbonus" :min="0"></el-input-number>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="col-left">
            <h2>
              Questions
              <a class="add-btn btn-empty" @click="open = true">
                <font-awesome-icon icon="plus"></font-awesome-icon>
              </a>
            </h2>
          </div>
          <div class="col-right">
            <div class="box-empty" v-if="round.questions.length === 0">
              <div>
                <font-awesome-icon class="icon" icon="question"></font-awesome-icon>
              </div>
              <div class="resume">There is no questions here, you can create by clicking on the "+" button below.</div>
            </div>
            <ul class="contest questions" v-if="round.questions &amp;&amp; round.questions.length &gt; 0">
              <li class="header">
                <div>Title</div>
                <div>Description</div>
                <div>Score</div>
                <div>Type</div>
                <div>Choices</div>
                <div></div>
              </li>
              <li class="item question" v-for="(question, index) in round.questions" :key="index">
                <div class="title">{{ question.title[lang] }}</div>
                <div>{{ question.description[lang] }}</div>
                <div>{{ question.score }}</div>
                <div>
                  <span class="tag black">{{ question.type }}</span>
                </div>
                <div>
                  <el-scrollbar>
                    <div style="max-height:80px;">
                      <span class="tag black" v-for="(value, index) in question.values" :key="index">{{ value }}</span>
                    </div>
                  </el-scrollbar>
                </div>
                <div>
                  <div class="group-actions">
                    <vue-dropdown
                      class="actions"
                      :actions="actions"
                      @action="action => handleAction(action, index)"
                    ></vue-dropdown>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <el-dialog v-if="round" :visible.sync="open" title="Create Question">
        <el-form label-position="left" label-width="140px">
          <el-form-item label="Title">
            <el-input v-model="tempQuestion.title[lang]"></el-input>
          </el-form-item>
          <el-form-item label="Description">
            <el-input v-model="tempQuestion.description[lang]"></el-input>
          </el-form-item>
          <el-form-item label="Score">
            <el-input-number v-model="tempQuestion.score" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="Type">
            <el-radio-group v-model="tempQuestion.type" @change="tempQuestion.values = []">
              <el-radio border="border" label="qcu">Unique answer</el-radio>
              <el-radio border="border" label="score">Score</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="First Team" v-if="tempQuestion.type === 'score'">
            <el-input v-model="tempQuestion.values[0]"></el-input>
          </el-form-item>
          <el-form-item label="Second Team" v-if="tempQuestion.type === 'score'">
            <el-input v-model="tempQuestion.values[1]"></el-input>
          </el-form-item>
          <el-form-item label="Response" v-if="tempQuestion.type === 'qcu'">
            <el-row>
              <el-col :span="15">
                <el-input v-model="tempQuestion.value" @keyup.enter.native="addResponse()"
                  ><template slot="append"
                    ><label @click="addResponse" style="cursor:pointer;"
                      ><font-awesome-icon icon="plus"></font-awesome-icon></label></template
                ></el-input>
              </el-col>
              <el-col class="center" :span="3">
                <div>&nbsp; - or - &nbsp;</div>
              </el-col>
              <el-col :span="6"
                ><label class="btn" for="uploadChoices"
                  ><font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>&nbsp; Upload</label
                ><input v-show="false" type="file" id="uploadChoices" @change="uploadResponse"
              /></el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="tempQuestion.type === 'qcu'">
            <el-scrollbar>
              <div class="listing-tags" style="height:140px;">
                <el-tag
                  v-for="(value, index) in tempQuestion.values"
                  :key="index"
                  closable="closable"
                  @close="handleRemoveChoice(index)"
                  >{{ value }}</el-tag
                >
              </div>
            </el-scrollbar>
          </el-form-item> </el-form
        ><span class="dialog-footer" slot="footer"
          ><el-button @click="open = false">{{ 'Cancel' }}</el-button
          ><el-button type="primary" @click="addQuestion">{{ 'Save' }}</el-button></span
        ></el-dialog
      >
    </template>
  </main-layout>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters, mapActions } from 'vuex'
import LineReader from '@/js/LineReader.js'
import VueDropdown from '@kevindesousa/vue-dropdown'

export default {
  name: 'round-form',

  props: {
    id: {
      type: String,
      required: false
    },
    idContest: {
      type: String,
      required: true
    }
  },

  components: { VueDropdown },

  data() {
    return {
      round: null,
      closedate: null,

      questionOpenedMoreAction: null,
      tempQuestion: {
        title: {},
        description: {},
        type: null,
        values: [],
        score: null,
        value: null
      },
      open: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('rounds', {
      roundById: 'roundById',
      getById: 'getById'
    }),

    title() {
      return this.id ? 'Edit round' : 'Create round'
    },

    actions() {
      return [
        {
          title: 'Edit',
          action: 'edit',
          icon: null
        },
        {
          title: 'Delete',
          action: 'delete',
          icon: null
        }
      ]
    }
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('rounds', ['loadRound', 'addRound', 'addResponses', 'updateRound', 'removeRound']),

    toggleEdit(question, index) {
      this.tempQuestion = JSON.parse(JSON.stringify(question))
      if (typeof index !== 'undefined') {
        this.tempQuestion.index = index
      }
      this.open = true
    },
    deleteQuestion(index) {
      this.round.questions.splice(index, 1)
    },
    save() {
      let zone = moment(this.closedate).utcOffset() * -1
      this.round.closedate =
        moment(this.closedate)
          .add(zone, 'minutes')
          .tz(this.site.timezone)
          .format('YYYY-MM-DD[T]HH:mm:ss') + 'Z'

      if (this.id) {
        this.updateRound({ round: this.round, sitekey: this.site.sitekey })
          .then(() => {
            this.$router.push({ name: 'Contest', params: { site: this.site.sitekey, id: this.idContest } })
            this.$notify({
              title: 'Success',
              message: this.$root.$t('notifications.round.mancheEdited'),
              type: 'success'
            })
          })
          .catch(e => {
            this.$notify.error({ title: 'Success', message: this.$root.$t('notifications.unknown') })
          })
      } else {
        this.addRound({ round: this.round, sitekey: this.site.sitekey })
          .then(() => {
            this.$router.push({ name: 'Contest', params: { site: this.site.sitekey, id: this.idContest } })
            this.$notify({
              title: 'Success',
              message: this.$root.$t('notifications.round.mancheAdded'),
              type: 'success'
            })
          })
          .catch(e => {
            this.$notify.error({ title: 'Success', message: this.$root.$t('notifications.unknown') })
          })
      }
    },

    handleAction(action, index) {
      switch (action) {
        case 'edit':
          this.toggleEdit(this.round.questions[index], index)
          break
        case 'delete':
          this.deleteQuestion(index)
          break
        default:
          break
      }
    },

    addResponse() {
      if (!this.tempQuestion.value) {
        return
      }
      if (/^\s+$/.test(this.tempQuestion.value)) {
        return
      }

      if (!this.tempQuestion.values.includes(this.tempQuestion.value)) {
        this.tempQuestion.values.push(this.tempQuestion.value)
      }

      this.tempQuestion.value = null
    },
    handleRemoveChoice(index) {
      this.tempQuestion.values.splice(index, 1)
    },
    /**
     * Upload file to add choices
     */
    uploadResponse(event) {
      const input = event.target
      if ('files' in input && input.files.length > 0) {
        // Create a new instance of the LineReader
        var lr = new LineReader()

        // Bind to the line event
        lr.on('line', (line, next) => {
          // Do something with line....
          if (line && !/^\s+$/.test(line) && !this.tempQuestion.values.includes(line)) {
            this.tempQuestion.values.push(line)
          }
          next() // Call next to resume...
        })
        // Begin reading the file
        lr.read(input.files[0])
      }
    },

    addQuestion() {
      if (this.tempQuestion.id) {
        this.round.questions.forEach((question, index) => {
          if (question.id === this.tempQuestion.id) {
            this.round.questions[index] = Object.assign({}, this.tempQuestion)
          }
        })
      } else {
        if (typeof this.tempQuestion.index !== 'undefined') {
          let question = Object.assign({}, this.tempQuestion)
          this.round.questions[this.tempQuestion.index] = question
        } else {
          let question = Object.assign({}, this.tempQuestion)
          this.round.questions.push(question)
        }
      }
      this.open = false
      this.tempQuestion = {
        title: {},
        description: {},
        type: null,
        values: [],
        score: null,
        value: null
      }
    },
    init() {
      if (this.site) {
        if (this.id) {
          this.loadRound({ id: this.id }).then(() => {
            let round = this.getById(this.id)
            this.round = this._.cloneDeep(round, false)
            this.closedate = round.closedate
          })
        } else {
          this.round = {
            contestid: this.idContest,
            title: {},
            description: {},
            closedate: null,
            questions: [],
            allgoodbonus: 10
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 21px;
  line-height: 1.14285714em;
  margin-bottom: 1.14285714em;
  letter-spacing: -0.025em;
  font-style: italic;
}

.contest.questions li {
  &.header {
    font-weight: 600;
  }

  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 3fr 60px;
  justify-items: center;
  align-items: center;
  border-bottom: 1px solid #ededed;
  padding: 0 12px;
  > div {
    padding: 8px;
  }
}

label.btn {
  height: 40px;
  line-height: 40px;
  background-color: #f5f7fa;
  color: #909399;
  border: 1px solid #dcdfe6;
  width: 100%;
  text-align: center;
  cursor: pointer;
}

.listing-tags {
  > * {
    margin: 4px 8px;
    white-space: pre;
  }
}
.item.question {
  span.tag {
    border: 1px solid #eaeaea;
    border-radius: 4px;
    margin: 4px 8px;
    display: inline-block;
  }

  .title {
    text-align: center;
    text-wrap: balance;
  }
}

.section {
  border-top: 1px solid #dedede;
  padding: 24px 0;
  &:first-child {
    border: 0;
  }

  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 20px;

  h2 {
    font-size: 21px;
    font-weight: 600;
  }

  .form-group {
    label {
      font-weight: 600;
      font-size: 14px;
      display: block;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      background: #fff;
      border: 1px solid #dedede;
      border-radius: 4px;
      display: block;
      line-height: 20px;
      font-size: 14px;
      padding: 6px 10px;
      color: rgb(46, 46, 46);
      box-sizing: border-box;
    }

    margin-bottom: 12px;
  }

  .form-submit {
    text-align: left;
  }
}

.btn-empty {
  background: #fff;
  border: 1px solid #777;
  color: #777;
}
.tag.black {
  color: #565656;
}
</style>



// WEBPACK FOOTER //
// src/pages/Contest/RoundForm.vue